import { ValidatorInput } from '../../../../model.module/validation/validation-descriptor.entity';
import { Directive, Input } from '@angular/core';
import BuergschaftCreateComponent from './bgsch-create.component';
import { CreateBuergscheinModel } from '../../../../model.module/create-buergschein.model';

@Directive()
export class BuergscheinCreateSuper {

    @Input()
    context: BuergschaftCreateComponent;

    @Input()
    printMode = false;

    canShowItem(validatorInput: ValidatorInput) {
        return validatorInput.valid === true && validatorInput.value && validatorInput.value.length;
    }

    canShowItemMultipleInputs(...validatorInputs: ValidatorInput[]) {
        return validatorInputs.reduce((previousValue, currentValue) => {
            return previousValue || this.canShowItem(currentValue);
        }, false);
    }

    translate(value: string): string {
        return CreateBuergscheinModel.translate(value);
    }

}
